import { PortalPartnerTypeEnum } from '@escapenavigator/types/dist/partners-portal/enum/portal-partner-type.enum';
import { Center, Loader } from '@mantine/core';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { AppLayout } from './components/app-layout';
import { AuthLayout } from './components/auth-layout';
import { DashboardPage } from './pages/dashboard';
import { EarningsPage } from './pages/earnings';
import { ForgotPasswordPage } from './pages/forgot-password';
import { LoginPage } from './pages/login';
import { MaterialsPage } from './pages/materials';
import { RegisterPage } from './pages/register';
import { SettingsPage } from './pages/settings';
import { StoriesPage } from './pages/stories';
import { StoryEditorPage } from './pages/story-editor';
import { VerifyEmailPage } from './pages/verify-email';
import { useAuth } from './providers/auth-context';

const RedirectStoryToQuest = () => {
    const { id } = useParams();

    return <Navigate to={id ? `/quests/${id}` : '/quests'} replace />;
};

export const App = () => {
    const { partner, initializing } = useAuth();

    if (initializing) {
        return (
            <Center h='100vh'>
                <Loader />
            </Center>
        );
    }

    if (!partner) {
        return (
            <Routes>
                <Route element={<AuthLayout />}>
                    <Route path='/login' element={<LoginPage />} />
                    <Route path='/register' element={<RegisterPage />} />
                    <Route path='/verify' element={<VerifyEmailPage />} />
                    <Route path='/forgot-password' element={<ForgotPasswordPage />} />
                </Route>
                <Route path='*' element={<Navigate to='/login' replace />} />
            </Routes>
        );
    }

    const isAuthor = partner.type === PortalPartnerTypeEnum.AUTHOR;

    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path='/' element={<DashboardPage />} />
                {isAuthor && <Route path='/quests' element={<StoriesPage />} />}
                {isAuthor && <Route path='/quests/new' element={<StoryEditorPage />} />}
                {isAuthor && <Route path='/quests/:id' element={<StoryEditorPage />} />}
                {isAuthor && <Route path='/stories' element={<Navigate to='/quests' replace />} />}
                {isAuthor && (
                    <Route path='/stories/new' element={<Navigate to='/quests/new' replace />} />
                )}
                {isAuthor && <Route path='/stories/:id' element={<RedirectStoryToQuest />} />}
                <Route path='/earnings' element={<EarningsPage />} />
                {!isAuthor && <Route path='/materials' element={<MaterialsPage />} />}
                <Route path='/settings' element={<SettingsPage />} />
            </Route>
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    );
};
